export default "__VITE_ASSET__22fa94b7__"